import { render, staticRenderFns } from "./BreastfeedingJourney.vue?vue&type=template&id=030d991d&scoped=true&"
import script from "./BreastfeedingJourney.vue?vue&type=script&lang=js&"
export * from "./BreastfeedingJourney.vue?vue&type=script&lang=js&"
import style0 from "./BreastfeedingJourney.vue?vue&type=style&index=0&id=030d991d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030d991d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VImg,VRow,VSheet})
